import { useSearchParams, Link } from 'react-router-dom';
import { Logo } from '../shell/Logo';

// GET /api/v1/auth/verify-email?token=... 은 서버가 302 로 /login?verified=true 리다이렉트한다.
// 즉 이 페이지에 직접 토큰을 들고 진입하는 일반 플로우는 거의 없다.
// 다만 사용자가 URL 을 잘못 따라왔거나, 토큰 없이 방문한 경우 안내 표시.
export default function VerifyEmailPage(): JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token');

  return (
    <div className="auth-page">
      <div className="auth-form">
        <div className="auth-form__brand">
          <Logo size={20} showText={false} />
          <span className="auth-form__brand-name">Alpha Omega Quant</span>
        </div>
        <h1>이메일 인증</h1>
        {token ? (
          <p>
            인증 링크를 처리하는 중입니다...<br />
            자동 이동이 되지 않으면{' '}
            <a href={`/api/v1/auth/verify-email?token=${encodeURIComponent(token)}`}>여기를 클릭</a>
            하세요.
          </p>
        ) : (
          <p>
            유효한 토큰이 없습니다. 회원가입 시 발송된 이메일의 링크를 클릭해주세요.
          </p>
        )}
        <Link to="/login">로그인으로</Link>
      </div>
    </div>
  );
}
